
import React, { useState } from "react";
import Mapir from "mapir-react-component";

const Map = Mapir.setToken({
    transformRequest: url => {
        return {
            url: url,
            headers: {
                "x-api-key": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImE4Yjc5MzA0MTFkNmMyZmUzNThhYmE0ZmEzYThlOGY2MzRiZTAwMzQ1MmViY2FmYTllNGFmZWE2M2U5NDRjYjk2NDdkZjg3MTI4NjIyNDEzIn0.eyJhdWQiOiIzMTM4MSIsImp0aSI6ImE4Yjc5MzA0MTFkNmMyZmUzNThhYmE0ZmEzYThlOGY2MzRiZTAwMzQ1MmViY2FmYTllNGFmZWE2M2U5NDRjYjk2NDdkZjg3MTI4NjIyNDEzIiwiaWF0IjoxNzQxMDgzMjI2LCJuYmYiOjE3NDEwODMyMjYsImV4cCI6MTc0MzU4ODgyNiwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.NhE2mNP4z4ZHPOyWziiw_77tBGmNySYGraXPvLfFUqMi6MPx7QNgiPjG__0Sg0jC7zvCI8dEs7hNNynAwHsdS9vlvRg0Z_RGRKkT34uTTGfJiUSHy5mamNlB61SPC-mzbSG2MbjeHlDIqnnH0EQs-I_gekb4-HNkKMsFI0mn8PNqhNfygBtFC40OG9LSbz9UTznmZNEVoBF_pVl2ZVSQ999-nUEM0h_qevLLjuBUj9IxW2Kl8ovqpICROIfzbf-2Dgy6hSiGSOotm-rLn2NpkfTwFbAH_niRit4SlGWk8orrNnU5zjANjOwv0eCeh2ZfWubhDFix0XbTiskYGCYZOw", 
                "Mapir-SDK": "reactjs"
            }
        };
    }
});

const MapIrJs = ({ initialLat = 35.6997, initialLng = 51.3378, onLocationChange }) => {
    const [location, setLocation] = useState({ lat: initialLat, lng: initialLng });

    // برای کلیک روی نقشه و ثبت مختصات
    const handleMapClick = (map, e) => {
        const { lng, lat } = e.lngLat; 
        setLocation({ lat, lng });
        if (onLocationChange) {
            onLocationChange(lat, lng );
        }
    };

    // برای دکمه "موقعیت من"
    const handleMyLocation = async (e) => {
        e.preventDefault(); // جلوگیری از ارسال فرم

        if (!navigator.geolocation) {
            alert("مرورگر شما از موقعیت مکانی پشتیبانی نمی‌کند.");
            return;
        }

        navigator.geolocation.getCurrentPosition(position => {
            const { latitude, longitude } = position.coords; 

            setLocation({ lat: latitude, lng: longitude });
            if (onLocationChange) {
                onLocationChange(latitude, longitude ); 
            }
        }, () => {
            alert("دسترسی به موقعیت مکانی امکان‌پذیر نیست.");
        });
    };

    return (
        <div>
            <button onClick={handleMyLocation} className="mb-1 btn btn-info">
                موقعیت من
            </button>

            <Mapir
                Map={Map}
                center={[location.lng, location.lat]}
                onClick={handleMapClick}
                zoom={[14]}
                 style="https://map.ir/vector/styles/main/mapir-xyz-style.json"
            >
                <Mapir.Marker coordinates={[location.lng, location.lat]} anchor="bottom" />
            </Mapir>
        </div>
    );
};
export default MapIrJs;